import React from 'react';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { colors, typography } from '../styles';
import ContactFormShort from '../pages/ContactUs/ContactFormShort';


const styles = css`
  padding-top:60px;

.Footer_contact {
  background: ${colors.color2};
  padding:20px;
  position: relative;
  max-width: 1600px;
  margin:20px 20px 20px 20px;
  @media (min-width: 992px) {
    padding:60px;
    margin:0 40px 40px 40px;
  }
  @media (min-width: 1680px) {
    padding:60px;
    margin:0 auto 100px auto;
  }
  h3 {
    color:  ${colors.color1};
    font:700 30px/1.4 ${typography.SansSerif};
    margin-bottom:30px;
    @media (min-width: 768px) {
      font:700 36px/1 ${typography.SansSerif};
    }
  }
  h3 span {
    color:  ${colors.color5};
    font:400 24px/1.4 ${typography.SansSerif};
    display:block;
    @media (min-width: 768px) {
      display:inline-block;
      font:400 28px/1.4 ${typography.SansSerif};
    }
  }
}
.Footer_contact_logo-bug {
  position:absolute;
  top: -36px;
  left: -35px;
}
.Footer_inner {

  @media (min-width: 992px) {
  }
}
.addy {
  padding: 0 0 5px 0;
  @media (min-width: 992px) {
    padding: 0 40px 5px 0;
  }
}
`;

function FooterForm() {
  return (
    <div className={styles}>
      <div className="Footer_wrapper">
        <div className="Footer_inner">
          <div className="Footer_contact">
            <h3>INTERESTED? <span>Talk with the builder today!</span></h3>
            <ContactFormShort />
          </div>
        </div>
      </div>
    </div>
  );
}


export default withData({

})(FooterForm);



// WEBPACK FOOTER //
// ./src/components/FooterForm.js